/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OpenVulnCountSnapshot } from './OpenVulnCountSnapshot';
import {
    OpenVulnCountSnapshotFromJSON,
    OpenVulnCountSnapshotFromJSONTyped,
    OpenVulnCountSnapshotToJSON,
    OpenVulnCountSnapshotToJSONTyped,
} from './OpenVulnCountSnapshot';
import type { KevFindingDto } from './KevFindingDto';
import {
    KevFindingDtoFromJSON,
    KevFindingDtoFromJSONTyped,
    KevFindingDtoToJSON,
    KevFindingDtoToJSONTyped,
} from './KevFindingDto';

/**
 * 
 * @export
 * @interface KevAssetGroupDto
 */
export interface KevAssetGroupDto {
    /**
     * 
     * @type {string}
     * @memberof KevAssetGroupDto
     */
    assetGoldenId?: string;
    /**
     * 
     * @type {string}
     * @memberof KevAssetGroupDto
     */
    assetClass?: string;
    /**
     * 
     * @type {string}
     * @memberof KevAssetGroupDto
     */
    hostname?: string;
    /**
     * 
     * @type {number}
     * @memberof KevAssetGroupDto
     */
    openFindingCount?: number;
    /**
     * 
     * @type {OpenVulnCountSnapshot}
     * @memberof KevAssetGroupDto
     */
    severityBreakdown?: OpenVulnCountSnapshot;
    /**
     * 
     * @type {Array<KevFindingDto>}
     * @memberof KevAssetGroupDto
     */
    findings?: Array<KevFindingDto>;
}

/**
 * Check if a given object implements the KevAssetGroupDto interface.
 */
export function instanceOfKevAssetGroupDto(value: object): value is KevAssetGroupDto {
    return true;
}

export function KevAssetGroupDtoFromJSON(json: any): KevAssetGroupDto {
    return KevAssetGroupDtoFromJSONTyped(json, false);
}

export function KevAssetGroupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): KevAssetGroupDto {
    if (json == null) {
        return json;
    }
    return {
        
        'assetGoldenId': json['assetGoldenId'] == null ? undefined : json['assetGoldenId'],
        'assetClass': json['assetClass'] == null ? undefined : json['assetClass'],
        'hostname': json['hostname'] == null ? undefined : json['hostname'],
        'openFindingCount': json['openFindingCount'] == null ? undefined : json['openFindingCount'],
        'severityBreakdown': json['severityBreakdown'] == null ? undefined : OpenVulnCountSnapshotFromJSON(json['severityBreakdown']),
        'findings': json['findings'] == null ? undefined : ((json['findings'] as Array<any>).map(KevFindingDtoFromJSON)),
    };
}

export function KevAssetGroupDtoToJSON(json: any): KevAssetGroupDto {
    return KevAssetGroupDtoToJSONTyped(json, false);
}

export function KevAssetGroupDtoToJSONTyped(value?: KevAssetGroupDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assetGoldenId': value['assetGoldenId'],
        'assetClass': value['assetClass'],
        'hostname': value['hostname'],
        'openFindingCount': value['openFindingCount'],
        'severityBreakdown': OpenVulnCountSnapshotToJSON(value['severityBreakdown']),
        'findings': value['findings'] == null ? undefined : ((value['findings'] as Array<any>).map(KevFindingDtoToJSON)),
    };
}

